import { createMiddlewareAction } from './createMiddlewareAction'
import { endpointsArticles } from '../api/endpoints'
import { productsTypes, familiesTypes } from '../constantes/actionTypes'

export const productsActions = {
  getArticlesOfAFatherId: (idFatherId) =>
    createMiddlewareAction({
      successType: productsTypes.GET_ARTICLES_BY_FATHER_ID_SUCCESS,
      failureType: productsTypes.GET_ARTICLES_BY_FATHER_ID_FAILURE,
      method: 'GET',
      endpoint: endpointsArticles.GET_ALL_ARTICLES_OF_A_FATHER(idFatherId),
    }),
  getArticlesByCategoryId: (idCategory) =>
    createMiddlewareAction({
      successType: productsTypes.GET_ARTICLES_BY_CATEGORY_ID_SUCCESS,
      failureType: productsTypes.GET_ARTICLES_BY_CATEGORY_ID_FAILURE,
      method: 'GET',
      endpoint: endpointsArticles.GET_ALL_ARTICLES_OF_A_CATEGORY(idCategory),
    }),
  getAllFinalProducts: () =>
    createMiddlewareAction({
      successType: productsTypes.GET_ALL_PRODUCTS_SUCCESS,
      failureType: productsTypes.GET_ALL_PRODUCTS_FAILURE,
      method: 'GET',
      endpoint: endpointsArticles.GET_ALL_FINAL_PRODUCTS,
    }),
  getAllFinalProductsBySearch: (search, page) =>
    createMiddlewareAction({
      successType: productsTypes.GET_ALL_PRODUCTS_BY_SEARCH_SUCCESS,
      failureType: productsTypes.GET_ALL_PRODUCTS_BY_SEARCH_FAILURE,
      method: 'GET',
      endpoint: endpointsArticles.GET_ALL_FINAL_PRODUCTS_BY_SEARCH(
        search,
        page,
      ),
    }),
  clearProductsList: () => ({
    type: productsTypes.CLEAR_PRODUCTS_LIST,
  }),
  newProduct: (product) =>
    createMiddlewareAction({
      successType: productsTypes.NEW_PRODUCT_SUCCESS,
      failureType: productsTypes.NEW_PRODUCT_FAILURE,
      method: 'POST',
      endpoint: endpointsArticles.NEW_ARTICLES,
      body: product,
    }),
  updateProduct: (product) =>
    createMiddlewareAction({
      successType: productsTypes.UPDATE_PRODUCT_SUCCESS,
      failureType: productsTypes.UPDATE_PRODUCT_FAILURE,
      method: 'PUT',
      endpoint: endpointsArticles.UPDATE_ARTICLES,
      body: product,
    }),
  deleteProduct: (idProduct) =>
    createMiddlewareAction({
      successType: productsTypes.DELETE_PRODUCT_SUCCESS,
      failureType: productsTypes.DELETE_PRODUCT_FAILURE,
      method: 'DELETE',
      endpoint: endpointsArticles.DELETE_ARTICLES(idProduct),
    }),
}

export const familiesActions = {
  getAllFolderProducts: () =>
    createMiddlewareAction({
      successType: familiesTypes.GET_ALL_FAMILIES_SUCCESS,
      failureType: familiesTypes.GET_ALL_FAMILIES_FAILURE,
      method: 'GET',
      endpoint: endpointsArticles.GET_ALL_FOLDER_PRODUCTS,
    }),
  getAllFamiliesBySearch: (search, page) =>
    createMiddlewareAction({
      successType: familiesTypes.GET_ALL_FAMILIES_BY_SEARCH_SUCCESS,
      failureType: familiesTypes.GET_ALL_FAMILIES_BY_SEARCH_FAILURE,
      method: 'GET',
      endpoint: endpointsArticles.GET_ALL_FOLDER_PRODUCTS_BY_SEARCH(
        search,
        page,
      ),
    }),
  clearFamiliesList: () => ({
    type: familiesTypes.CLEAR_FAMILIES_LIST,
  }),
  newFamily: (family) =>
    createMiddlewareAction({
      successType: familiesTypes.NEW_FAMILY_SUCCESS,
      failureType: familiesTypes.NEW_FAMILY_FAILURE,
      method: 'POST',
      endpoint: endpointsArticles.NEW_ARTICLES,
      body: family,
    }),
  updateFamily: (family) =>
    createMiddlewareAction({
      successType: familiesTypes.UPDATE_FAMILY_SUCCESS,
      failureType: familiesTypes.UPDATE_FAMILY_FAILURE,
      method: 'PUT',
      endpoint: endpointsArticles.UPDATE_ARTICLES,
      body: family,
    }),
  deleteFamily: (idFamily) =>
    createMiddlewareAction({
      successType: familiesTypes.DELETE_FAMILY_SUCCESS,
      failureType: familiesTypes.DELETE_FAMILY_FAILURE,
      method: 'DELETE',
      endpoint: endpointsArticles.DELETE_ARTICLES(idFamily),
    }),
}
